//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'ReleaseNotesMobile',
  methods: {
    goToBack() {
      this.$router.go(-1);
    },
  },
};
